/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircles = createReactComponent("circles", "IconCircles", [
  ["path", { d: "M12 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", key: "svg-0" }],
  ["path", { d: "M6.5 17m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", key: "svg-1" }],
  ["path", { d: "M17.5 17m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", key: "svg-2" }]
]);

export { IconCircles as default };
//# sourceMappingURL=IconCircles.js.map
